import {Component, Input, OnInit} from '@angular/core';
import {SectionResult} from '../../placement-group-view.component';
import {PlacementTestSectionModel} from '../../../../../models/edu-admin/placement-test.model';
import {AssetsHelper} from '../../../../../models/extensions/assets-helper.model';

@Component({
  selector: 'app-placement-group-section-card-detailed',
  templateUrl: './placement-group-section-card-detailed.component.html',
  styleUrls: ['./placement-group-section-card-detailed.component.css']
})
export class PlacementGroupSectionCardDetailedComponent implements OnInit {

  @Input() index = 1;
  @Input() numStudents = 0;
  @Input() placementSection: PlacementTestSectionModel;
  @Input() sectionResult: SectionResult;

  constructor() { }

  ngOnInit() {
  }

  categoryIcon(): string {
    return AssetsHelper.categoryIconURL(this.placementSection.category);
  }

  avgMasteryForSection(): string {

    if (this.sectionResult) {
      return this.sectionResult.avgSkillMasteryForSection(this.numStudents);
    }

    return '0';
  }

  numSkillsInSection(): string {

    if (this.placementSection) {
      return this.placementSection.orderedQuestions.length.toString(10);
    }

    return '0';
  }

}
